import {Directive, OnDestroy, OnInit, Optional, TemplateRef} from '@angular/core';

import {HeaderContainer} from './header-container.service';

/**
 * The maiaFullViiewOverlayHeader directive can be used to mark a part of the
 * maia full-view-overlay content as part of the header instead of the general content.
 *
 * @ngModule LayoutModule
 */
@Directive({selector: '[maiaFullViewOverlayHeader]'})
export class FullViewOverlayHeaderDirective implements OnInit, OnDestroy {
  public constructor(
    private readonly _template: TemplateRef<any>,
    @Optional() private readonly _container: HeaderContainer,
  ) {
    // HeaderContainer is optional so we can throw our own error instead of the generic error when a
    // parameter can't be found in the injector.
    if (this._container == null) {
      throw new Error(
        '*maiaFullViewOverlayHeader can only be used inside a full-view-overlay content component',
      );
    }
  }

  public ngOnInit(): void {
    this._container.setHeader(this._template);
  }

  public ngOnDestroy(): void {
    this._container.setHeader(undefined);
  }
}
